module.exports = __webpack_public_path__ + "img/complaintTypes.a2a38522.svg";